import { useState, useCallback } from 'react';

interface PendingDeletion {
  name: string;
  onConfirm: () => void;
}

export function useDeleteConfirmation() {
  const [pending, setPending] = useState<PendingDeletion | null>(null);

  const requestDelete = useCallback(
    (name: string, onConfirm: () => void) => {
      setPending({ name, onConfirm });
    },
    [],
  );

  const cancel = useCallback(() => setPending(null), []);

  const confirm = useCallback(() => {
    pending?.onConfirm();
    setPending(null);
  }, [pending]);

  return {
    pending,
    isOpen: pending !== null,
    requestDelete,
    cancel,
    confirm,
  };
}
